import e from"react";import{ThemeProvider as t}from"styled-components";var r=function(r){var m=r.theme,n=void 0===m?{isMobile:!1}:m,o=r.children;return e.createElement(t,{theme:n},e.createElement(e.Fragment,null,o))};export{r as Theme};
